import { useState } from "react";
import { Link } from "react-router-dom";
import { useAdminWebsites } from "../../hooks/use-admin.js";
import { PageSkeleton } from "../../components/skeleton.js";

function truncateId(id: string): string {
  return id.length > 8 ? id.slice(0, 8) + "\u2026" : id;
}

function formatDate(dateStr: string | null): string {
  if (!dateStr) return "\u2014";
  return new Date(dateStr).toLocaleDateString("en-IE");
}

export function AdminWebsitesPage() {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const { data, isLoading } = useAdminWebsites({
    page,
    limit: 50,
    search: search || undefined,
  });

  if (isLoading) return <PageSkeleton />;

  return (
    <div className="product-page">
      <h1 className="page-title">Websites</h1>
      <input
        type="search"
        placeholder="Search by domain or URL\u2026"
        aria-label="Search websites by domain or URL"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setPage(1);
        }}
        className="admin-search mb-3"
      />
      {data && (
        <>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Domain</th>
                <th>Org</th>
                <th className="text-center">Score</th>
                <th>Status</th>
                <th>Last Scan</th>
                <th className="text-center">Docs</th>
                <th className="text-center">Recurring</th>
              </tr>
            </thead>
            <tbody>
              {data.websites.map((w) => (
                <tr key={w.id}>
                  <td>
                    <Link to={`/admin/websites/${w.id}`}>{w.domain}</Link>
                  </td>
                  <td className="text-sm text-muted">
                    <Link to={`/admin/orgs/${w.orgId}`} title={w.orgId}>
                      {truncateId(w.orgId)}
                    </Link>
                  </td>
                  <td className="text-center text-sm">
                    {w.latestScore !== null ? `${w.latestScore}%` : "\u2014"}
                  </td>
                  <td className="text-sm">
                    {w.verified ? "\u2713 Verified" : "Not verified"}
                  </td>
                  <td className="text-sm text-muted">
                    {formatDate(w.latestReportAt)}
                  </td>
                  <td className="text-center text-sm">
                    {w.documentScanEnabled ? "Yes" : "No"}
                  </td>
                  <td className="text-center text-sm">
                    {w.recurringEnabled ? "Yes" : "No"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {data.websites.length === 0 && (
            <p className="text-muted text-center p-4">
              No websites found.
            </p>
          )}
          <div className="d-flex gap-2 items-center mt-3">
            <button
              type="button"
              className="btn btn--secondary btn--sm"
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              disabled={page === 1}
            >
              Previous
            </button>
            <span className="text-muted text-sm">
              Page {page} &middot; {data.total} total
            </span>
            <button
              type="button"
              className="btn btn--secondary btn--sm"
              onClick={() => setPage((p) => p + 1)}
              disabled={data.websites.length < 50}
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
}
